import * as Yup from 'yup';

export default Yup.object().shape({
  marketing_personal_data_consent: Yup.boolean(),
  consent_to_the_processing_of_personal_data_after_termination_of_the_contract: Yup.boolean(),
});
